import {action, observable, computed} from 'mobx';
import http from "../../http";

class CabinetMainPageStore {
    _routerStore;
    _authStore;
    _bookingHistoryStore;
    @observable showSpinner = true;
    @observable loading = false;
    @observable user_stat_id = null;
    @observable stats;
    @observable banner;
    @observable push;
    @observable orders;
    @observable history_orders = [];
    @observable waiting_orders = [];
    @observable accepted_orders = [];
    @observable history_is_last = true;
    @observable accepted_is_last = true;
    @observable waiting_is_last = true;
    @observable history_loading = false;
    @observable accepted_loading = false;
    @observable waiting_loading = false;
    @observable history_page = 1;
    @observable accepted_page = 1;
    @observable waiting_page = 1;
    @observable is_wide_screen = false;
    @observable openAlert = false;
    @observable alertMessage = '';
    @observable alertMessageType = 'success';
    @observable show_cancel_dialog = false;
    @observable cancel_order_id = null;

    constructor(routerStore, authStore, bookingHistoryStore) {
        this._routerStore = routerStore
        this._authStore = authStore
        this._bookingHistoryStore = bookingHistoryStore
        this.is_wide_screen = window.innerWidth >= 1024;
    }

    @computed
    get user() {
        return this._authStore.user
    }

    load = async () => {
        let isRedirect = false;
        if (this._routerStore.history.location && this._routerStore.history.location.pathname) {
            isRedirect = !this._routerStore.history.location.pathname.includes('booking/cabinet');
        }

        if (this.user && ((this.user_stat_id !== this.user.id && !this.loading) || isRedirect)) {
            this.loading = true;
            await Promise.resolve()
                .then(() => this.loading = true)
                .then(() => this.showSpinner = true)
                .then(() => this.user_stat_id = this.user.id)
                .then(this.getUserStats)
                .then(this.getBookingList)
                .then(this.getBanner)
                .then(this.getPush)
                .then(() => this.loading = false)
                .then(() => this.showSpinner = false)
                .catch(console.log)
        }
    }

    paginate = async (type) => {
        const loadingField = `${type}_loading`
        return await Promise.resolve()
            .then(() => this[loadingField] = true)
            .then(() => this.getOrdersPaginate(type))
            .then(() => this[loadingField] = false)
            .catch(() => this[loadingField] = false)
    }

    cancelOrderClick = async (id) => {
        return await Promise.resolve()
            .then(() => this.cancel_order_id = id)
            .then(() => this.show_cancel_dialog = true)
    }

    cancelOrderCallback = async () => {
        return await Promise.resolve()
            .then(() => this.loading = true)
            .then(() => this.show_cancel_dialog = false)
            .then(() => this.cancelOrder(this.cancel_order_id))
            .catch(() => this.cancel_order_id = null)
            .then(() => this.getBookingList())
            .then(() => this.loading = false)
    }

    @action
    getBanner = () => {
        return http.get(`/banners/random`)
            .then(({data}) => {
                this.banner = data;
            })
    }

    @action
    getPush = () => {
        return http.get(`/push`)
            .then(({data}) => {
                this.push = data;
            })
    }

    @action
    logout = () => {
        this._authStore.logout();
    }

    @action
    getBookingList = async () => {
        return http.get(`/appointments/booking-list?is_wide_screen=${this.is_wide_screen}`)
            .then(({data}) => {
                this.waiting_orders = data.content.waiting.items
                this.accepted_orders = data.content.accepted.items
                this.history_orders = data.content.history.items
                this.accepted_is_last = data.content.accepted.is_last_page
                this.waiting_is_last = data.content.waiting.is_last_page
                this.history_is_last = data.content.history.is_last_page
            })
            .catch(console.log)
    };

    @action
    getUserStats = async () => {
        return http.get(`/appointments/stats`)
            .then(({data}) => {
                this.stats = data.content
            })
            .then(() => this.loading = false)
            .catch(console.log)
    };

    @action
    cancelOrder = async () => {
        return http.post(`/appointments/cancel-order?id=${this.cancel_order_id}`)
            .then(({data}) => {
                this.openAlert = true
                this.alertMessage = data.content.message
                this.alertMessageType = 'success';
            })
            .catch(({response}) => {
                if (response && response.data && response.data.message) {
                    this.alertMessage = response.data.message
                } else {
                    this.alertMessage = 'Что-то пошло не так :('
                }
                this.openAlert = true
                this.alertMessageType = 'error';
            })
    };

    @action
    getOrdersPaginate = async (type) => {
        const lastPageField = `${type}_is_last`,
            pageField = `${type}_page`,
            ordersField = `${type}_orders`;
        return http.get(`/appointments/orders-paginate?is_wide_screen=${this.is_wide_screen}&type=${type}&page=${this[pageField] + 1}`)
            .then(({data}) => {
                this[ordersField] = this[ordersField].concat(data.content)
                this[lastPageField] = data.is_last_page
                this[pageField] = this[pageField] + 1;
            })
            .catch(console.log)
    };
}

export {CabinetMainPageStore};
